import { ClearHistoryDialog } from './clear-history-dialog/clear-history-dialog.component';
import { DIALOG_STYLE } from '../../../../assets/css/ag/styles';
import { StorageService } from './../../../services/storage/storage.service';
import { SearchService } from './../../../services/search/search.service';
import { SearchHistoryService } from './search-history.service';
import { Component, SimpleChanges, Input, OnChanges, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { MoreDetailsDialog } from './more-details-dialog/more-details-dialog.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ANIMATION_MODULE_TYPE } from '@angular/platform-browser/animations';
import { KidsCatalogSearchService } from '../../../pages/kids-catalog-search/kids-catalog-search.service';
import { LayoutService } from '../../../services/layout.service';
import { SidenavContent } from '../sidenav-content';
import { SharedService } from '../../../services/shared/shared.service';

@Component({
  selector: 'search-history',
  templateUrl: './search-history.component.html',
  styleUrls: ['./search-history.component.scss'],
  providers: [{ provide: ANIMATION_MODULE_TYPE, useValue: 'BrowserAnimations' }],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class SearchHistoryComponent extends SidenavContent implements OnChanges {
  @Input() searchHistrory: any;
  @Input() refreshPage: boolean;

  currentSaveSearches: any;
  maxSaveSearches: any;
  loading: any;

  constructor(
    private _dialog: MatDialog,
    private _kidsCatalogSearchService: KidsCatalogSearchService,
    private _snackBar: MatSnackBar,
    private _router: Router,
    private _layoutService: LayoutService,
    private _searchHistoryService: SearchHistoryService,
    private _searchService: SearchService,
    private _storageService: StorageService,
    public sharedService: SharedService,
  ) {
    super(_layoutService);
    this.loading = true;
  }

  getSearchHistory(): void {
    this._searchHistoryService.getSearchHistory().subscribe((response) => {
      if (response.status === 'OK') {
        this.searchHistrory = response.data.searchHistory;
        this.currentSaveSearches = response.data.numOfSavedSearches;
        this.maxSaveSearches = response.data.maxSearchesToSave;
        this.loading = false;
      }
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes) {
      this.loading = true;
      if (changes.searchHistrory) {
        setTimeout(() => {
          const response = changes.searchHistrory.currentValue;
          if (response) {
            this.searchHistrory = response.searchHistory;
            this.currentSaveSearches = response.numOfSavedSearches;
            this.maxSaveSearches = response.maxSearchesToSave;
            this.loading = false;
          }
        }, 500);
      }
    }
  }

  refresh() {
    this.loading = true;
    this._searchHistoryService.getSearchHistory().subscribe((response) => {
      if (response.status === 'OK') {
        this.openSnackBar('updated', 'ok');
        this.searchHistrory = response.data.searchHistory;
        this.currentSaveSearches = response.data.numOfSavedSearches;
        this.maxSaveSearches = response.data.maxSearchesToSave;
        this.loading = false;
      }
    });
  }

  modify(info) {
    // 1. save the query in session or BS
    // set a flag to check the user is coming from searchHistory or not
    this._searchHistoryService.setModifySearchBSBS(info);
    this._storageService.setItem('history', info);
    this.closeNav();
    this._router.navigate(['/advancedsearch'], {
      queryParams: {
        history: true,
      },
    });
  }

  search(searchRequest) {
    const Cid: string = this._storageService.getCid();
    const Lid: string = this._storageService.getLid();
    let sortBy: string;
    this._storageService.setItem('history', searchRequest);
    // save the query in search-term object in session to retain the term on search
    const array = searchRequest.searchQuery.matches;
    let queryString = '';
    for (let index = 0; index < array.length; index++) {
      const element = array[index];
      if (index == 0) {
        queryString = element.query;
        this._storageService.setItem('Search-TERM', queryString);
      } else {
        queryString = queryString + ',' + element.query;
        const q2 = this._storageService.getItem('Search-TERM');
        const dummyStr = q2 + ' ' + element.query;
        this._storageService.setItem('Search-TERM', dummyStr);
      }
    }
    this._storageService.setItem('Search-TERM', queryString);
    switch (searchRequest.searchQuery.sortBy[0]) {
      case 'relevance':
        sortBy = 'relevance';
        break;
      case 'title_asc':
        sortBy = 'title_asc';
        break;
      case 'title_desc':
        sortBy = 'title_desc';
        break;
      case 'author_asc':
        sortBy = 'author_asc';
        break;
      case 'author_desc':
        sortBy = 'author_desc';
        break;
      default:
        sortBy = 'relevance';
        break;
    }
    this.closeNav();
    this._searchService.doSearch(searchRequest);
  }

  async performKidsSearchAndRoutingAsync(searchRequest, queryString, Cid, Lid): Promise<void> {
    this._kidsCatalogSearchService.setKidsCacheSearchRequest(searchRequest);
    const kidsResponse = await this._kidsCatalogSearchService.performKidsSearchAsync(searchRequest);

    if (!kidsResponse) {
      throw new Error(
        `failed to fetch kidsCat results in search history with cid: ${Cid} and lid:${Lid} on ${new Date()}`,
      );
    }

    this.closeNav();
    this._kidsCatalogSearchService.kidsCatBindingsandRouting(
      kidsResponse,
      kidsResponse.searchId,
      queryString,
    );
  }

  // ----------------- clear search history -------------------------------

  clear() {
    this.openClearHistoryDialog();
  }

  openClearHistoryDialog(): void {
    const dialogRef = this._dialog.open(ClearHistoryDialog, {
      panelClass: DIALOG_STYLE.MD,
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result == 'yes') {
        this._searchHistoryService.clearSearchHistory().subscribe((response) => {
          if (response.status === 'OK') {
            this.openSnackBar(response.message, 'ok');
            this.loading = true;
            // get the latest search history
            this._searchHistoryService
              .getSearchHistory()
              // .pipe(map(res => res))
              .subscribe((response) => {
                if (response.status === 'OK') {
                  this.searchHistrory = response.data.searchHistory;
                  this.currentSaveSearches = response.data.numOfSavedSearches;
                  this.maxSaveSearches = response.data.maxSearchesToSave;
                  this.loading = false;
                }
              });
          }
        });
      }
    });
  }

  // -------------- more details -------------------------

  moreDetails(details) {
    this.openMoreDetailsDialog(details);
  }

  openMoreDetailsDialog(data): void {
    this._dialog.open(MoreDetailsDialog, {
      panelClass: DIALOG_STYLE.MD,
      // disableClose: true,
      data: { details: data },
    });
  }

  // --------------------- user experience ----------------------

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 3000,
      verticalPosition: 'top',
    });
  }
}
